import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  color: #888;
  font-size: 14px;
  padding-left: 10px;
`;

export const Label = styled.div`
  padding-top: 2px;
`;
